import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel, Keyboard } from 'swiper';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import 'swiper/css';
import Style from './index.css';

const throttle = (func, delay) => {
    let lastCall = 0;

    return (...args) => {
        const now = new Date().getTime();

        if (now - lastCall < delay) {
            return;
        }
        lastCall = now;

        return func.apply(this, args);
    };
};

const Page3 = (props) => {
    const { peopleList, onChangeMaskVisible, onChangeCurrentVideo, peopleIndex, onChangePeopleIndex } = props;
    const defaultImage = 'https://x0.ifengimg.com/ucms/2025_21/3FD81D96A1786D0F1D17F5F38F8298744CD12B22_size189_w1687_h660.png';
    const swiperRef = useRef();

    const openVideo = (video) => {
        onChangeCurrentVideo({
            url: video.videoUrl,
            duration: video.videoDuration,
            guid: video.videoGuid,
        });
        onChangeMaskVisible(true);
    };

    useEffect(() => {
        swiperRef.current.slideToLoop(peopleIndex);
    }, [peopleIndex]);

    // console.log(peopleIndex, 'peopleIndex');

    return (
        <div className={Style.page5}>
            <img
                className={`${Style.navigation} ${Style.navigationL}`}
                onClick={() => {
                    onChangePeopleIndex(swiperRef.current.realIndex);
                }}
                src="https://x0.ifengimg.com/ucms/2025_21/B251CD52F05D57B202DA73B52C91171EF3FC5865_size3_w69_h127.png"
            />
            <Swiper
                modules={[Navigation, Mousewheel, Keyboard]}
                className={Style.swiper}
                speed={1500}
                mousewheel={{
                    forceToAxis: true,
                }}
                keyboard={{
                    enabled: true,
                }}
                navigation={{
                    nextEl: `.${Style.navigationR}`,
                    prevEl: `.${Style.navigationL}`,
                }}
                initialSlide={peopleIndex}
                loop={false}
                onKeyPress={(e) => {
                    onChangePeopleIndex(swiperRef.current.realIndex);
                }}
                onSlideChange={(swiper) => {
                    onChangePeopleIndex(swiper.realIndex);
                    console.log(swiper.realIndex);
                }}
                onSwiper={(swiper) => (swiperRef.current = swiper)}>
                {peopleList.map((item, index) => {
                    const posterImage = item?.tenQuestion?.poster || '';

                    return (
                        <SwiperSlide key={index} onClick={() => openVideo(item.tenQuestion)}>
                            <div className={Style.images}>
                                {posterImage ? (
                                    <img className={Style.posterImage} src={posterImage} onClick={() => openVideo(item.tenQuestion)} />
                                ) : (
                                    <img className={Style.posterImage} src={defaultImage} />
                                )}
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>

            <img
                className={`${Style.navigation} ${Style.navigationR}`}
                onClick={() => {
                    onChangePeopleIndex(swiperRef.current.realIndex);
                }}
                src="https://x0.ifengimg.com/ucms/2025_21/93FE47FFC16150E66207FE6DC842DDEF6171C468_size3_w68_h126.png"
            />

            <div className={Style.peopleList}>
                {peopleList.map((people, index) => {
                    return (
                        <div key={index}>
                            <div
                                className={`${Style.people} ${index === peopleIndex ? Style.active : ''}`}
                                onClick={() => {
                                    // swiperRef.current.slideToLoop(index);
                                    onChangePeopleIndex(index);
                                    // throttle(onChangePeopleIndex(index), 800);
                                }}>
                                {people.name}
                            </div>
                            {index < peopleList.length - 1 && <span className={Style.divider}>/</span>}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

Page3.propTypes = {
    peopleList: PropTypes.array,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
    peopleIndex: PropTypes.number,
    onChangePeopleIndex: PropTypes.func,
};

export default errorBoundary(Page3);
